import React from 'react';
import { Helmet } from 'react-helmet';

const DEFAULT_IMAGE = 'https://zosa.app/zosaog.png';

function Seo({
  title,
  description,
  keywords,
  canonical,
  image,
  noindex = false
}) {
  // Default SEO metadata if not provided
  const defaultTitle = 'ZOSA | There\'s always another layer to discover';
  const defaultDescription = 'Getting through it, or getting better at it. Take a new approach to self-understanding with ZOSA.';
  const defaultKeywords = 'ZOSA, ZOSA app, ZOSA AI, mental health support, someone to talk to, anxiety help, affordable therapy alternative, AI therapy, AI therapist, therapy chatbot, AI mental health, mood tracker, self awareness app, mental fitness, AI journal, track your patterns, mental well-being, personalised therapy, online therapy, anonymous therapy, anonymous AI chatbot, private AI companion, encrypted journal, secure mental health platform';
  const defaultCanonical = 'https://zosa.app/';

  const metaTitle = title || defaultTitle;
  const metaDescription = description || defaultDescription;
  const metaKeywords = keywords || defaultKeywords;
  const metaCanonical = canonical || defaultCanonical;
  const metaImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      {/* Title */}
      <title>{metaTitle}</title>

      {/* Description */}
      <meta name="description" content={metaDescription} />

      {/* Keywords */}
      <meta name="keywords" content={metaKeywords} />

      {/* Indexing directive - private and auth pages opt out */}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />

      {/* Canonical URL */}
      <link rel="canonical" href={metaCanonical} />

      {/* Open Graph (OG) Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="ZOSA" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={metaCanonical} />
      <meta property="og:image" content={metaImage} />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </Helmet>
  );
}

export default Seo;
